<template>
  <div id="home"
       class="container-fluid has-action-bar has-footer">
    <div>
      <div id="homeActionBar"
           class="row align-items-center"
           @click.stop="drawer = !drawer">
        <div class="col-4 py-0 text-right ">
          <i class="fal fa-bars nav-menu-icon round"></i>
        </div>
        <div class="col-4 py-0 font22px text-center">
          پیشرو
        </div>
        <div v-if="schoolInfo !==null&&schoolInfo !==undefined" class="col-4 py-2 text-left">
          <img
              :src="$replaceHttps(schoolInfo.schoolLogo)" alt="logo" height="40"/>
        </div>
      </div>
      <SidebarNavigation v-model="drawer"/>
    </div>
    <div class="row container mx-auto no-gutters p-0">
      <div class="col-12 ">
        <div v-if="isLoaded " class="row">
          <div class="col-12">
            <carousel
                :autoplay="true"
                :dots="false"
                :items="1"
                :margin="5"
                :nav="false"
                :rtl="true">
              <div v-for="item in banner"
                   :key="item.BanerID">
                <img v-if="item.FileUrl !==null" :src="$replaceHttps(item.FileUrl)" alt="بنر"
                     class="img-fluid rounded-xl"
                     @click="openLink(item.Link)">
              </div>
            </carousel>
          </div>
        </div>
        <div v-if="hasKnowledgeCategories">
          <div v-if="categories.length > 0" class="row">
            <div class="col-12" dir="ltr">
              <div class="col-12 p-0 rounded-b header-rounded text-center bg-white"
                   style="border:1px solid var(--primary-color)">
                <div class="primary-background header-rounded mb-3 text-center font16px white--text p-2">پایگاه دانش
                </div>
                <div class="row mx-1">
                  <div class="col-12">
                    <carouselLtr
                        :autoplay="true"
                        :dots="false"
                        :margin="25"
                        :nav="false"
                        :responsive="{0:{items:4,nav:false},600:{items:7,nav:false}}"
                        :rtl="true">
                      <div v-for="item in categories"
                           :key="item.KnowledgeCategoryID">
                        <div v-if="item.IsFirstPage">
                          <div class="fourth-background round p-1 cursor-pointer"
                               @click="goToKnowledgeBaseStep2(item.KnowledgeCategoryID,item.Name)">
                            <div style="min-height: 65px">
                              <v-img v-if="item.FileUrl !== null" :alt="item.Name" :src="$replaceHttps(item.FileUrl)"
                                     contain height="65">
                              </v-img>
                            </div>
                          </div>
                          <div class="text-center mt-3 line-height-1-5 font12px">{{ item.Name }}</div>
                        </div>
                      </div>
                    </carouselLtr>
                    <div class="col-12 text-center mt-3 pb-0">
                      <v-btn class="primary" rounded small @click="navigateTo('KnowledgeBase')">
                        <span class="font12px">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mx-auto">
            <div v-if="schoolInfo !== null &&schoolInfo !==undefined" class="fourth-background rounded-b-xl">
              <div class="third-background rounded-t-xl py-1 mb-3"></div>
              <div class="text-center">
                <img :src="$replaceHttps(schoolInfo.schoolLogo)" alt="logo" height="90">
                <div class="mt-2 font-weight-bold">{{ schoolInfo.schoolName }}</div>
              </div>
              <div class="row no-gutters">
                <table v-if="userInfo !== null" class="col-12">
                  <tbody class="table-list">
                  <tr>
                    <td class="font16px">مشخصات دانش آموز</td>
                  </tr>
                  <tr>
                    <td>نام و نام خانوادگی</td>
                    <td>{{ userInfo.firstName }} {{ userInfo.lastName }}</td>
                  </tr>

                  <tr>
                    <td>پایه</td>
                    <td>{{ userInfo.studentGrade }}</td>
                  </tr>
                  <tr>
                    <td>کلاس</td>
                    <td>{{ userInfo.studentClass }}</td>
                  </tr>
                  <tr v-if="packageDataLoaded">
                    <td>نوع کاربری ( اشتراک )</td>
                    <td v-if="hasActivePackage">{{ paymentPackageData.Name }}</td>
                    <td v-else>فاقد اشتراک</td>
                  </tr>
                  <tr v-if="packageDataLoaded && hasActivePackage">
                    <td>باقیمانده اشتراک</td>
                    <td>{{ packageExpireDay }} روز</td>
                  </tr>
                  </tbody>
                </table>
                <div class="text-center col-12 white-border-top p-2">
                  <v-btn v-if="hasActivePackage" class="gradient-btn" rounded
                         @click="goToPackageDetail(paymentPackageData.PackageID)">مشاهده
                  </v-btn>
                  <v-btn v-else class="gradient-btn" rounded @click="navigateTo('BuyMembership')">خرید اشتراک</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-if="userInfo !==null" class="col-12 col-md-6 mx-auto cursor-pointer"
               @click="navigateTo('SpecialFile')">
            <v-img
                :src="getImgUrl('bg-purple.png')"
                contain>
              <div class="center-card text-center ">
                <v-avatar size="75">
                  <img v-if="userLogo !==  null && userLogo !== ''"
                       :src="$replaceHttps(userLogo)"
                       alt="عکس دانش آموز">
                  <img
                      v-else
                      :src="getImgUrl('logo.svg')"
                      alt="عکس دانش آموز">
                </v-avatar>
                <div class="font16px white--text mt-2"><span
                    class="white-border-bottom px-4 pb-2 ">{{ userInfo.firstName }} {{ userInfo.lastName }}</span>
                </div>
                <div class="font16px white--text mt-2">پرونده اختصاصی</div>
              </div>
            </v-img>
          </div>
        </div>

        <div class="row container m-0 p-0">
          <div class="col-6 pr-0 pl-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="navigateTo('OnlineExam')">
              <img :src="getImgUrl('online-test.png')" alt="آزمون آنلاین" height="65"/>
              <div class="mt-4 font16px">آزمون آنلاین</div>
            </v-alert>
          </div>
          <div class="col-6 pl-0 pr-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="navigateTo('SurveyList')">
              <img :src="getImgUrl('vote.png')" alt="نظز سنجی" height="65"/>
              <div class="mt-4 font16px">نظرسنجی</div>
            </v-alert>
          </div>
        </div>
        <div class="row container m-0 p-0">
          <div v-if="onlineClassLink !== '' && onlineClassLink !== null" class="col pr-0 pl-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="$openLink(onlineClassLink)">
              <img :src="getImgUrl('onlineClass.png')" alt="کلاس آنلاین" height="65"/>
              <div class="mt-4 font16px">کلاس آنلاین</div>
            </v-alert>
          </div>
          <div v-if="onlineSessionLink !== '' && onlineSessionLink !== null" class="col pl-0 pr-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="$openLink(onlineSessionLink)">
              <img :src="getImgUrl('onlineSession.png')" alt="جلسه آنلاین" height="65"/>
              <div class="mt-4 font16px">جلسه آنلاین</div>
            </v-alert>
          </div>
        </div>
        <div class="row container m-0 p-0">
          <div class="col-6 pr-0 pl-1 py-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="primary"
                colored-border
                elevation="0"
                @click="navigateTo('ClassScores')">
              <img :src="getImgUrl('exam.png')" alt="نمرات کلاسی">
              <div class="mt-2 font16px">نمرات کلاسی</div>
            </v-alert>
          </div>
          <div class="col-6 pl-0 pr-1 py-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="primary"
                colored-border
                elevation="0"
                @click="navigateTo('WeeklySchedule')">
              <img :src="getImgUrl('organize.png')" alt="برنامه هفتگی">
              <div class="mt-4 font16px">برنامه هفتگی</div>
            </v-alert>
          </div>
        </div>
        <div class="row container m-0 p-0">
          <div class="col-6 pr-0 pl-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="navigateTo('bmi')">
              <img :src="getImgUrl('bmi.png')" alt="bmi" height="65"/>
              <div class="mt-4 font16px">BMI</div>
            </v-alert>
          </div>
          <div class="col-6 pl-0 pr-1 pb-0 cursor-pointer">
            <v-alert
                border="left"
                class="py-6 text-center rounded-l-lg alert-border"
                color="forth"
                colored-border
                elevation="0"
                @click="navigateTo('SleepQuality')">
              <img :src="getImgUrl('sleeping.png')" alt="ساعت خواب" height="65"/>
              <div class="mt-4 font16px">ساعت خواب</div>
            </v-alert>
          </div>
        </div>
        <div class="row mt-0">
          <div class="col-12 col-sm-6 pt-0 ">
            <v-img
                :src="getImgUrl('bg-report.png')" class="rounded-xl bg-report-shadow cursor-pointer"
                @click="navigateTo('SpecialReports')">
              <div class="center-card text-center">
                <img alt="گزارشات ویژه" class="img-fluid" src="../assets/img/report.png">
                <div class="font16px white--text mt-4">گزارشات ویژه</div>
              </div>
            </v-img>
          </div>
          <div class="col-12 col-sm-6 pt-0 ">
            <v-img
                :src="getImgUrl('bg-keyboard.png')"
                class="rounded-xl bg-keyboard-shadow cursor-pointer" @click="navigateTo('Performance')">
              <div class="center-card text-center">
                <img alt="ثبت عملکرد" class="img-fluid" src="../assets/img/keyboard.png">
                <div class="font16px white--text keyboard-title mt-4">ثبت عملکرد دانش آموز خارج از مدرسه</div>
              </div>
            </v-img>
          </div>
        </div>
        <div class="row">
          <div class="col-6 ">
            <v-img :src="getImgUrl('bg-star.png')" class="rounded-xl bg-star-shadow cursor-pointer" max-height="211"
                   @click="navigateTo('Points')">
              <div class="center-card">
                <img :src="getImgUrl('star.png')" alt="امتیازات" class="img-fluid mt-5 pt-2 mb-3">
                <div class="font16px white--text">امتیازات</div>
              </div>
            </v-img>
          </div>
          <div class="col-6 text-center ">
            <v-img :src="getImgUrl('bg-student.png')" class="rounded-xl bg-student-shadow cursor-pointer"
                   max-height="211"
                   @click="navigateTo('Attendance')">
              <div class="center-card">
                <img :src="getImgUrl('student.png')" alt="حضور و غیاب" class="img-fluid mt-5 pt-2 mb-3">
                <div class="font16px white--text category-title">حضور و غیاب</div>
              </div>
            </v-img>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="showModal"
        hide-overlay
        persistent
        width="500">
      <v-card>
        <v-card-title class="justify-center ">{{ modalHeader }}</v-card-title>
        <v-card-text class="pb-0 text-right">
          <div class="mb-0 black--text">{{ modalText }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="closeModal">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showSleepAlertDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">ثبت ساعت خواب</div>
          <div class="mb-0 black--text font12px">ساعت خواب فرزند خود را ثبت کنید</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="primary" rounded @click="closeSleepModalAndNavigate">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showBMIAlertDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">ثبت BMI</div>
          <div class="mb-0 black--text font12px">پارامترهای BMI فرزند خود را ثبت کنید</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="primary" rounded @click="closeBMIModalAndNavigate">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FooterMenu/>
  </div>
</template>

<script>
import moment from "moment-jalaali";

let _this = null;
import SidebarNavigation from "../components/SidebarNavigation";
import carousel from 'xx-vue-owl-carousel';
import carouselLtr from 'vue-owl-carousel'
import FooterMenu from "../components/FooterMenu";


export default {
  name: "Home",
  metaInfo: {
    title: 'مسیربرتر-خانه'
  },
  components: {
    FooterMenu,
    SidebarNavigation,
    carousel,
    carouselLtr
  },
  data: () => ({
    drawer: false,
    hasKnowledgeCategories: false,
    banner: [],
    categories: [],
    isLoaded: false,
    schoolInfo: null,
    userInfo: null,
    showModal: false,
    modalText: '',
    modalHeader: '',
    paymentPackageData: null,
    packageExpireDay: null,
    hasActivePackage: null,
    packageDataLoaded: false,
    packageData: null,
    userLogo: null,
    onlineClassLink: '',
    onlineSessionLink: '',
    showSleepAlertDialog: false,
    showBMIAlertDialog: false
  }),
  mounted() {
    _this = this;
    this.getKnowledgeBaseData();
    this.getData();
    this.getModal();
    this.getOnlineLink();

    this.schoolInfo = this.$getSchoolInfo();
    this.userInfo = this.$getUserData();
    this.userLogo = this.$getUserLogo().studentPicture;

    this.getPackagePaymentHistory();
  },
  methods: {
    getOnlineLink() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Index", requestOptions)
          .then(response => response.text())
          .then(result => {

            let json = (JSON.parse(result));

            this.onlineClassLink = json.onlineClassLink
            this.onlineSessionLink = json.onlineSessionLink
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/SchoolBanner", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = (JSON.parse(result)).Baners
            _this.banner = json.filter(x => x.IsActive === true)
            if (this.banner.length > 0) {
              _this.isLoaded = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getPackagePaymentHistory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let now = this.$convertDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

      let date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      let yearAgo = this.$convertDate(new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))

      let urlencoded = new URLSearchParams();

      urlencoded.append("AppUserID", this.$getUserData().userID);
      urlencoded.append("StartDate", yearAgo);

      urlencoded.append("EndDate", now);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageReportManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            json.sort(function (a, b) {
              return new Date(b.ModifiedDate) - new Date(a.ModifiedDate);
            });
            let paymentHistory = json.filter(x => x.IsExpire === false)
            if (paymentHistory.length > 0) {
              _this.packageData = paymentHistory[0]

              if (paymentHistory[0] !== undefined) {
                let currentDate = new Date()
                let date2 = new Date(currentDate);
                let date1 = new Date(paymentHistory[0].ExpireDate);
                _this.paymentPackageData = paymentHistory[0]

                _this.packageExpireDay = (Math.abs(date2 - date1) / (1000 * 3600 * 24)).toFixed();
              }
            }
            _this.checkPackageData()
          })
          .catch(error => console.log('error', error));
    },
    checkPackageData() {
      let packageHistory = this.paymentPackageData
      if (packageHistory === null) {
        this.hasActivePackage = false
      } else {
        this.hasActivePackage = true
        _this.paymentPackageData = this.packageData
      }
      this.packageDataLoaded = true

    },
    getModal() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ModalAppManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);
            let lastModal = json.at(-1)
            let modalID = _this.$getModalID()
            if (json.length > 0) {
              if (modalID !== null) {
                if (modalID !== lastModal.ModalAppID) {
                  _this.showModal = true
                  _this.modalHeader = lastModal.Name
                  _this.modalText = lastModal.Description
                  _this.$setModalID(lastModal.ModalAppID)
                } /*else {
                  this.getSleepTimeStatus();
                }*/
              } else {
                _this.showModal = true
                _this.modalHeader = lastModal.Name
                _this.modalText = lastModal.Description
                _this.$setModalID(lastModal.ModalAppID)
              }
            } /*else {
              this.getSleepTimeStatus();
            }*/

          })
          .catch(error => console.log('error', error));
    },
    getKnowledgeBaseData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "KnowledgeManagement/ListKnowledgeCategory", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);

            _this.showLoaderDialog = false
            let active = json.filter(x => x.IsActive === true && x.IsFirstPage === true)

            if (active.length > 0) {
              _this.categories = active
              this.hasKnowledgeCategories = true
            } else {
              this.hasKnowledgeCategories = false

            }
          })
          .catch(error => {
            _this.showLoaderDialog = false
            console.log('error', error)
          });
    },
    goToKnowledgeBaseStep2(id, name) {
      this.$router.push({path: 'KnowledgeBaseStep2', query: {KnowledgeCategoryID: id, title: name}})
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    navigateTo(path) {
      if (this.$router.currentRoute.fullPath.indexOf(path) === -1) {
        this.$router.push({path: path});
      }
    },
    openLink(link) {
      if (link !== null) {
        _this.$openLink(link)
      }
    },
    goToPackageDetail(id) {
      this.$router.push({path: 'BuyMembershipPackageDetail', query: {PackageID: id}})
    },
    getSleepTimeStatus() {
      let currentDate = new Date(new Date().setDate(new Date().getDate() - 1));
      //let currentDate = new Date();
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("registerDate", this.$convertDate(currentDate.toISOString()));
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_IsSleepQualityRegistered", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length === 0) {
              this.showSleepAlertDialog = true;
            } else {
              this.getBmiStatus();
            }
          })
          .catch(error => console.log('error', error));
    },
    closeSleepModalAndNavigate() {
      this.showSleepAlertDialog = false;
      this.navigateTo("SleepQuality");
    },
    getBmiStatus() {
      let currentDate = new Date()
      let m = moment(currentDate)
      m.format('jYYYY/jMM/jDD')
      let month = (m.format('jMM'))
      let year = m.format('jYYYY')
      let jalaliEndDate = null
      let jalaliStartDate = year + '/' + month + '/' + '01'
      if (month >= 1 && month <= 6) {
        jalaliEndDate = year + '/' + month + '/' + '31'
      } else {
        jalaliEndDate = year + '/' + month + '/' + '30'

      }
      // let startDate = this.$convertDateToMiladi(jalaliStartDate)
      // let endDate = this.$convertDateToMiladi(jalaliEndDate)

      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", jalaliStartDate);
      urlencoded.append("EndDate", jalaliEndDate);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      /*for (const [key, value] of urlencoded.entries()) {

      }*/
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_Bmi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length === 0) {
              _this.showBMIAlertDialog = true;
            }
          })
          .catch(error => console.log('error', error));
    },
    closeBMIModalAndNavigate() {
      this.showBMIAlertDialog = false;
      this.navigateTo("bmi");
    },
    closeModal() {
      //this.getSleepTimeStatus();
      this.showModal = false;
    }
  }
}
</script>

<style scoped>

</style>